import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    makeStyles,
} from '@material-ui/core';
import { DescriptionOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    dialog: {
        borderRadius: 16,
        padding: theme.spacing(2),
    },
    content: {
        padding: theme.spacing(4),
        textAlign: 'center',
    },
    iconContainer: {
        width: 80,
        height: 80,
        borderRadius: '50%',
        backgroundColor: '#EEF4FF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 24px',
    },
    icon: {
        fontSize: 40,
        color: '#376fd0',
    },
    title: {
        color: '#1A1A1A',
        marginBottom: 16,
        fontWeight: 600,
    },
    message: {
        color: '#4A4A4A',
    },
    serviceName: {
        fontWeight: 600,
        color: '#1A1A1A',
    },
    actions: {
        padding: '16px 24px',
        gap: 12,
    },
    button: {
        borderRadius: 8,
        textTransform: 'none',
        padding: '8px 24px',
        '&.primary': {
            backgroundColor: '#376fd0',
            '&:hover': {
                backgroundColor: '#2B5DB3',
            },
        },
        '&.secondary': {
            borderColor: '#376fd0',
            color: '#376fd0',
            '&:hover': {
                backgroundColor: '#F5F8FF',
            },
        },
    },
}));

const MissingMainDocumentModal = ({ open, serviceName, onClose, onAttach }) => {
    const classes = useStyles();

    const serviceLabel = serviceName ? `de ${serviceName}` : 'do serviço';

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ className: classes.dialog }}
        >
            <DialogContent className={classes.content}>
                <Box className={classes.iconContainer}>
                    <DescriptionOutlined className={classes.icon} />
                </Box>

                <Typography variant="h5" className={classes.title}>
                    Falta o documento principal
                </Typography>

                <Typography variant="body1" className={classes.message}>
                    Para concluir esta entrega, suba o documento principal{' '}
                    <span className={classes.serviceName}>{serviceLabel}</span>.
                </Typography>
            </DialogContent>

            <DialogActions className={classes.actions}>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    className={`${classes.button} secondary`}
                >
                    Fechar
                </Button>
                <Button
                    onClick={onAttach}
                    variant="contained"
                    className={`${classes.button} primary`}
                    style={{ color: '#FFFFFF' }}
                >
                    Anexar documento
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MissingMainDocumentModal;
